import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect } from "react";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import SprintDetails from "../../input-components/test-summary-report/SprintDetails";
import Introduction from "../../input-components/test-summary-report/IntroductionPage";
import TestCoverage from "../../input-components/test-summary-report/TestCoverage";
import DefectDistribution from "../../input-components/test-summary-report/DefectDistribution";
import DeferredDefectDetails from "../../input-components/test-summary-report/DeferredDefectDetails";
import References from "../../input-components/test-summary-report/References";
import SummaryReportScope from "../../input-components/test-summary-report/SummaryReportScope";
import { testSummaryReportContext } from "../TestSummaryReportPage";
import { useLocation } from "react-router-dom";

const TestSummaryOutputPage = () => {
  const location = useLocation();
  const {
    introduction,
    setIntroduction,
    scope,
    setScope,
    sprintDetails,
    setSprintDetails,
    testCoverage,
    setTestCoverage,
    defectDistribution,
    setDefectDistribution,
    defectDetails,
    setDefectDetails,
    references,
    setReferences,
  } = useContext(testSummaryReportContext);

  useEffect(() => {
    if (location.state?.introductionData) {
      setIntroduction(location.state.introductionData);
    }
    if (location.state?.scopeData) {
      setScope(location.state.scopeData);
    }
    if (location.state?.sprintDetailsData) {
      setSprintDetails(location.state.sprintDetailsData);
    }
    if (location.state?.testCoverageData) {
      setTestCoverage(location.state.testCoverageData);
    }
    if (location.state?.defectDistributionData) {
      setDefectDistribution(location.state.defectDistributionData);
    }
    if (location.state?.defectDetailsData) {
      setDefectDetails(location.state.defectDetailsData);
    }
  }, [
    location.state?.introductionData || {},
    location.state?.scopeData || {},
    location.state?.sprintDetailsData || {},
    location.state?.testCoverageData || {},
    location.state?.defectDistributionData || {},
    location.state?.defectDetailsData || {},
  ]);
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "601px",
        margin: "10px auto",
        "& > *:not(:last-child)": {
          marginBottom: "16px", // Adds margin between components but not after the last one
        },
        // height: "100%",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        position={"sticky"}
        top={0}
      >
        <Box display="flex">
          <AutomateIcon style={{ marginRight: 4 }} />
          {/* Informative text */}
          <Typography
            variant="body2"
            color="text.secondary"
            gutterBottom
            sx={{ mt: 0.5 }}
            fontSize={"12px"}
          >
            Generate a comprehensive test summary report
          </Typography>
        </Box>
        {/* <FullscreenIcon sx={{width: "24px"}}/> */}
        <FullscreenToggle />
      </Box>

      {/* //Test Summary Introductipon Page */}
      {<Introduction />}

      {/* //Test Summary Scope Page */}
      {Object.entries(introduction).length > 0 && <SummaryReportScope />}

      {/* //Test Summary Sprint Details Page */}
      {Object.entries(scope).length > 0 && <SprintDetails />}

      {/* //Test Summary Test Coverage Page */}
      {Object.entries(sprintDetails).length > 0 && <TestCoverage />}

      {/* //Test Summary Defect Distribution Page */}
      {Object.entries(testCoverage).length > 0 && <DefectDistribution />}

      {/* //Test Summary Defect Details Page */}
      {Object.entries(defectDistribution).length > 0 && (
        <DeferredDefectDetails />
      )}

      {/* //Test Summary References Page */}
      {Object.entries(defectDetails).length > 0 && <References />}

      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>
    </Box>
  );
};

export default TestSummaryOutputPage;
